import { request } from '../utils/httpClient';

export const searchUsers = (data) => {
  let url = '/users/search';
  if (data.searchText) {
    url += `?query=${data.searchText}`;
  }

  if (data.chapter) {
    url += `&chapter=${data.chapter}`;
  }

  if (data.membersOnly) {
    url += `&members_only=${data.membersOnly}`;
  }

  if (data.spd) {
    url += `&spd=${data.spd}`;
  }

  return request({
    url: url,
    method: 'GET',
  });
};

export const getUser = (data) => {
  return request({
    url: `/users/${data.id}`,
    method: 'GET',
  });
};

export const updateUser = (data) => {
  let userId = data.id;
  delete data.id;
  return request({
    url: `/users/${userId}`,
    method: 'PATCH',
    data: data,
  });
};

export const createUser = (data) => {
  return request({
    url: '/users',
    method: 'POST',
    data: data,
  });
};

export const createUsers = (data) => {
  return request({
    url: '/users/create',
    method: 'POST',
    data: data,
  });
};

export const createUserAddress = (data) => {
  let userId = data.id;
  delete data.id;
  return request({
    url: `/users/${userId}/address`,
    method: 'POST',
    data: data,
  });
};

export const removeUserAddress = (data) => {
  return request({
    url: `/users/address/${data.addressId}`,
    method: 'DELETE',
  });
};

export const createUserMember = (data) => {
  let memberId = data.memberId;
  delete data.memberId;

  return request({
    url: `/users/member/${memberId}`,
    method: 'POST',
    data: data,
  });
};

export const getRoles = () => {
  return request({
    url: 'users/roles',
    method: 'GET',
  });
};

export const getApplications = () => {
  return request({
    url: 'users/applications',
    method: 'GET',
  });
};

export const getReports = () => {
  return request({
    url: 'users/reports',
    method: 'GET',
  });
};
export const getUserList = (data) => {
  let url = `/users/?page=${data.page}&page_size=${data.rowsPerPage}`;

  if (data.search) {
    url += `&search=${data.search}`;
  }

  if (data.userType) {
    url += `&type=${data.userType}`;
  }

  if (data.spd) {
    url += `&spd=${data.spd}`;
  }

  return request({
    url: url,
    method: 'GET',
  });
};

export const getUserDetail = (data) => {
  return request({
    url: `/users/${data.id}`,
    method: 'GET',
  });
};

export const getUserPermissions = (data) => {
  return request({
    url: `/users/${data.id}/permissions`,
    method: 'GET',
  });
};

export const updateUserPermissions = (data) => {
  let userId = data.id;
  delete data.id;

  return request({
    url: `/users/${userId}/permissions`,
    method: 'PATCH',
    data: data,
  });
};

export const getUserRoles = () => {
  return request({
    url: `/users/permissions/roles`,
    method: 'GET',
  });
};

export const getUserApplications = () => {
  return request({
    url: `/users/permissions/applications`,
    method: 'GET',
  });
};

export const getUserReports = () => {
  return request({
    url: `/users/permissions/reports`,
    method: 'GET',
  });
};

export const createSPDElectionLoader = (data) => {
  return request({
    url: `/membership/spd_election_load`,
    method: 'POST',
    data: data,
  });
};

export const getUserCommittees = (data) => {
  return request({
    url: `/users/${data.id}/committees`,
    method: 'GET',
  });
};

export const getUserNotes = (data) => {
  return request({
    url: `/users/${data.id}/notes`,
    method: 'GET',
  });
};

export const getUserNoteTypes = () => {
  return request({
    url: '/users/notes/types',
    method: 'GET',
  });
};

export const createUserNote = (data) => {
  return request({
    url: `/users/${data.userId}/notes`,
    method: 'POST',
    data: data.data,
  });
};

export const updateUserNote = (data) => {
  let noteId = data.noteId;
  delete data.noteId;

  return request({
    url: `/users/${data.userId}/notes/${noteId}`,
    method: 'PATCH',
    data: data.data,
  });
};

export const deleteUserNote = (data) => {
  return request({
    url: `/users/${data.userId}/notes/${data.noteId}`,
    method: 'DELETE',
  });
};

export const getUserPI = (data) => {
  return request({
    url: `/users/${data.id}/personal-info`,
    method: 'GET',
  });
};

export const updateUserPI = (data) => {
  let userId = data.id;
  delete data.id;

  return request({
    url: `/users/${userId}/personal-info`,
    method: 'PATCH',
    data: data,
  });
};

export const getUserProjects = (data) => {
  return request({
    url: `/users/${data.id}/projects`,
    method: 'GET',
  });
};

export const getUserUpdateHistory = (data) => {
  return request({
    url: `/users/${data.id}/update_history`,
    method: 'GET',
  });
};

export const getTransferRequestInfo = (data) => {
  if (data.chapter_size && data.chapter_size === 'all') {
    delete data.chapter_size;
  }
  if (data.chapter_type && data.chapter_type === 'all') {
    delete data.chapter_type;
  }
  return request({
    url: `/users/seeking_transfer/locations`,
    method: 'POST',
    data: data,
  });
};

export const getTransferRequestInfoInitial = (data) => {
  return request({
    url: `/users/seeking_transfer/locations/initial/${data.userId}`,
    method: 'GET',
  });
};

export const createUserTransferRequest = (data) => {
  return request({
    url: `/users/transfer_requests`,
    method: 'POST',
    data: data,
  });
};

export const getUserTransferRequestList = () => {
  return request({
    url: `/users/transfer_requests`,
    method: 'GET',
  });
};

export const getSeekingTransferDetail = (data) => {
  return request({
    url: `/users/transfer_requests/${data.id}`,
    method: 'GET',
  });
};

export const postSeekingTransferNote = (data) => {
  return request({
    url: `/users/transfer_requests/${data.id}/notes`,
    method: 'POST',
    data: data,
  });
};

export const deleteSeekingTransferNote = (data) => {
  return request({
    url: `/users/transfer_requests/${data.id}/notes/${data.noteId}`,
    method: 'DELETE',
  });
};

export const updateSeekingTransferNote = (data) => {
  return request({
    url: `/users/transfer_requests/${data.id}/notes/${data.noteId}`,
    method: 'PATCH',
    data: data,
  });
};

export const updateSeekingTransfer = (data) => {
  return request({
    url: `/users/transfer_requests/${data.id}`,
    method: 'PATCH',
    data: data,
  });
};

export const transferPost = (data) => {
  return request({
    url: `/users/transfer`,
    method: 'POST',
    data: data,
  });
};

export const initiateMember = (data) => {
  return request({
    url: `/users/initiate`,
    method: 'POST',
    data: data,
  });
};
